import { useEffect, useState } from 'react';

import { CircularProgressFullScreen } from '../components/shared_new/CircularProgressFullScreen/CircularProgressFullScreen';
import useLeadChannelStore from '../store/leadChannelStore/useLeadChannelStore';
import useParameterStore from '../store/parameterStore/useParameterStore';

const CmsGuard = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { initLeadChannel, initLeadChannelFinished } = useLeadChannelStore();
  const [fetchingLeadChannel, setFetchingLeadChannel] = useState(true);

  const { leadChannelCode } = useParameterStore();

  useEffect(() => {
    if (initLeadChannelFinished) {
      setFetchingLeadChannel(false);
      return;
    }

    initLeadChannel(leadChannelCode);
  }, [initLeadChannel, initLeadChannelFinished]);

  if (fetchingLeadChannel) {
    return <CircularProgressFullScreen />;
  }

  return children;
};

export default CmsGuard;
